import { helpers } from 'vuelidate/lib/validators'

export const requireBigAlpha = helpers.regex('requireBigAlpha', /[A-Z]/)
export const requireSmallAlpha = helpers.regex('requireSmallAlpha', /[a-z]/)
export const requireNum = helpers.regex('requireNum', /[0-9]/)
export const onlyAlphaAndSpecSymbols = helpers.regex(
  'requireNum',
  // eslint-disable-next-line
  /^[a-zA-Z0-9!@#$%^&*()-_+=;:,.\/?\|\\`~\[\]{}.]*$/
)
